<template>
  <a-modal :visible="visible" :width="1200" title="选择项目" :footer="null" @cancel="$emit('cancel')">
    <div class="pb-6 overflow-hidden">
      <div class="float-left overflow-hidden">
        <span class="float-left pr-2 leading-8">搜索:</span>
        <a-textarea class="float-left" style="width: 200px" autoSize v-model="queryParam.custom.search"
          placeholder="请输入要搜索的内容" @pressEnter="press_enter"></a-textarea>
      </div>
      <div class="float-left pl-6 overflow-hidden">
        <span class="float-left pr-2 leading-8">投标日期:</span>
        <a-range-picker class="float-left" v-model="queryParam.time.bidder_timef" format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD" />
      </div>
      <div class="float-left pl-6">
        <a-button type="primary" class="mr-2" @click="gets(1)" icon="search">搜索</a-button>
        <a-button type="default" @click="reset" icon="reload">重置</a-button>
      </div>
      <div class="float-right" v-if="permission(['contract', 'apply/:id?'], 'new_project')">
        <a-button type="primary" @click="formFlag = true" icon="plus">添加项目</a-button>
      </div>
    </div>
    <a-table :loading="loading" :columns="columns" :data-source="list" :pagination="pagination" bordered row-key="id"
      size="small" :customRow="customRow">
      <template slot="proprietor" slot-scope="text">
        <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
      </template>
      <template slot="name" slot-scope="text">
        <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
      </template>
      <template slot="money" slot-scope="text">
        {{ text > 0 ? text : '' }}
      </template>
      <template slot="bidder_timef" slot-scope="text">
        {{ text }}
      </template>
      <template slot="action" slot-scope="text, record">
        <span>
          <a @click="select(record)" class="text-green-500">选择</a>
        </span>
      </template>
    </a-table>
    <ProjectForm :visible="formFlag" @cancel="formFlag = false" @ok="gets(1)"></ProjectForm>
  </a-modal>
</template>
<script>
import { projects_byindex } from '@/api/project';
import ProjectForm from './project-form.vue';
import { columns } from './_project';
import permission from '@/utils/permission';
// import { temp_categorys } from '@/api/temp';
// import { findByKey } from '@/utils/tool';
export default {
  components: {
    ProjectForm,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      columns,
      queryParam: { custom: { search: '' }, time: {}, eq: {} },
      loading: true,
      pagination: {
        current: 1,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page;
          this.gets();
        },
      },
      list: [],
      search: '',
      formFlag: false,
      // activeKey: '',
      // tempCategorys: [],
    };
  },
  watch: {
    visible(a) {
      if (a) {
        this.gets(1);
      }
    },
  },
  async created() {
    // this.tempCategorys =
    //   (
    //     await temp_categorys({
    //       qp: JSON.stringify({ eq: { review: 1 } }),
    //       orderby: 'a.sort desc',
    //     })
    //   ).data || [];
    this.gets(1);
  },
  methods: {
    permission,
    // findByKey,
    customRow(record) {
      return {
        on: {
          dblclick: (event) => {
            this.$emit('ok', record);
          },
        },
      };
    },
    // changeTab(e) {
    //   this.queryParam.eq.temp_category_id = e;
    //   this.activeKey = e;
    //   this.gets(1);
    // },
    async gets(current) {
      this.loading = true;
      if (current) {
        this.pagination.current = current;
      }
      this.search = this.queryParam.custom.search;
      let res = await projects_byindex({
        current: this.pagination.current,
        qp: JSON.stringify(this.queryParam),
      });
      this.list = res.data || [];
      this.$set(this.pagination, 'total', res.total);
      this.loading = false;
    },
    select(record) {
      this.$emit('ok', record);
    },
    reset() {
      this.queryParam = { custom: { search: '' }, time: {}, eq: {} };
      this.gets(1);
    },
    press_enter(e) {
      e.preventDefault();
      this.gets(1);
    },
  },
};
</script>
